import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledTitle = styled.div`
  margin-bottom: 20px;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textTitle};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 17px;
  margin: 16px 0 30px;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  letter-spacing: 0.2px;
  color: ${({ theme }) => theme.colors.textTitle};

  p {
    margin-bottom: 0;
  }
`

export const StyledButton = styled.button`
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 48px;
  border: none;
  outline: none;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  padding: 12px 0;
  width: 100%;
  cursor: pointer;
`

export const StyledItemContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.textTitle};

  &:last-child {
    margin-bottom: 0;
  }
`

export const StyledIcon = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 20px;
`

export const StyledItemTitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 22.4px;
  text-align: left;
`

export const StyledItemDesc = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 16.8px;
  text-align: left;
`

export const StyledNote = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16.34px;
  color: ${({ theme }) => theme.colors.textTertiary};
`

export const StyledLink = styled.a`
  font-size: 12px;
  font-weight: 500;
  line-height: 16.34px;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;

  :hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`
